import ForgotPassword from "@/src/screens/auth/forgot-password-screen/forgot-password-screen";

function ForgotPasswordPage() {
  return <ForgotPassword />;
}

export default ForgotPasswordPage;
